import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'

import * as comparison from './comparison'
import * as selection from './selection'
import * as statement from './statement'

export const TRANSFORMER = graphql.transformers.IN.object<
  ents.extra.rate.gl.Filter,
  graphql.schema.GeneralLedgerFilterInput
>({
  comparison: filter =>
    ents.extra.rate.gl.Filter.Comparison.isProbablyComparison(filter)
      ? comparison.TRANSFORMER.getGqlFrom(filter)
      : undefined,
  selection: filter =>
    ents.extra.rate.gl.Filter.Selection.isProbablySelection(filter)
      ? selection.TRANSFORMER.getGqlFrom(filter)
      : undefined,
  statement: filter =>
    ents.extra.rate.gl.Filter.Statement.isProbablyStatement(filter)
      ? statement.TRANSFORMER.getGqlFrom(filter)
      : undefined,
})
